import PackingRoutes from "./packing.js";
import HarvestExportRoutes from './harvest_export';

export default [...PackingRoutes, ...HarvestExportRoutes];
